import I18n from "common/i18n";
import { BuilderCommandId, CommandLimits } from "features/builder/types";
import { COMMAND_OPTIONS, COMMAND_CATEGORIES } from "features/builder/commandOptions";

export const MapDetailCommandPanel = ({
  enabledCommands,
  commandLimits = {},
}: {
  enabledCommands: Set<BuilderCommandId>;
  commandLimits?: CommandLimits;
}) => {
  return (
    <div className="flex-col-el items-start w-full gap-4">
      <p className="type-text-left type-sm text-textcolor-black/60 w-full">
        {I18n.t("MSG_BUILDER_DETAIL_COMMAND_DESC")}
      </p>

      {COMMAND_CATEGORIES.map((category) => (
        <div key={category.id} className="flex-col-el items-start w-full gap-2">
          <p className="type-text-left type-md text-textcolor-black w-full">
            {I18n.t(category.labelKey)}
          </p>
          <div className="flex-col-el w-full gap-2">
            {COMMAND_OPTIONS.filter((b) => b.category === category.id).map((block) => {
              const isEnabled = enabledCommands.has(block.id);
              const limit = commandLimits[block.id];
              return (
                <div
                  key={block.id}
                  className={`flex-row-el items-center gap-3 px-4 py-3 rounded-xl border-solid border-2 ${
                    isEnabled
                      ? `${category.bgClass} ${category.borderClass}`
                      : "bg-gray2-10 border-gray2-30 opacity-60"
                  }`}
                >
                  <span
                    className={`material-symbols-outlined type-md ${
                      isEnabled ? category.accentClass : "text-gray2-100"
                    }`}
                  >
                    {block.icon}
                  </span>
                  <p
                    className={`type-text-left type-sm flex-1 ${
                      isEnabled ? "text-textcolor-black" : "text-textcolor-black/60"
                    }`}
                  >
                    {I18n.t(block.labelKey)}
                  </p>
                  {isEnabled && (
                    <p className="type-text type-sm text-textcolor-black whitespace-nowrap">
                      {limit != null
                        ? I18n.t("MSG_BUILDER_COMMAND_LIMIT_COUNT", { count: limit })
                        : I18n.t("MSG_BUILDER_COMMAND_LIMIT_UNLIMITED")}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};
